import { Button } from '@/components/ui/button';

export default function AboutPage() {
  return (
    <div className="flex flex-col justify-center px-10 pt-10 text-center">
      <h1 className="pb-3 text-2xl text-secondary">Product safety in the EU</h1>
      <p className="text-white">
        Product safety in the EU This game is part of the EU product safety
        initiative, the Coordinated Activities on the Safety of Products (CASP).
        Market surveillance authorities from all EU countries, plus Iceland,
        Liechtenstein and Norway are working together on CASP 2024. They will
        jointly test several popular products, identify their risks, improve
        communication about product safety and help ensure a safer market for
        everyone. CASP 2024 is testing baby soothers, high chairs, bicycles for
        children and slime toys, lighting chains, mini electric heaters and
        disposable e-cigarettes. The EU has legislation in place to ensure
        that{' '}
      </p>

      <div className="flex grow justify-center">
        <Button variant="secondary" className="mt-10 w-60">
          Continue
        </Button>
      </div>
    </div>
  );
}
